import React, { useState } from "react";

const UpcomingProjects = () => {
  const projects = [
    {
      id: 1,
      name: "Upcoming Project – Near Mominpet",
      developer: "NAKSHATRA INFRA PROJECTS",
      location: "Mominpet, Hyderabad",
      type: "DTCP &RERA Approved Open Plots ",
      overview:
        "A large-scale DTCP approved gated community spread across 100 acres, thoughtfully planned for long-term appreciation and peaceful living. This project combines modern infrastructure, clear legal status, and green surroundings, making it an excellent choice for both investors and future homeowners.",
      keyInfo: {
        plotSizes: "Starting from 167 Sq. Yards",
        totalArea: "100 Acres",
        status: "Coming Soon",
        booking: "Open for Early Investors"
      },
      highlights: [
        "DTCP Approved Layout with Clear Title",
        "100 Acres Mega Gated Community",
        "Wide Black Top Roads & Internal Connectivity",
        "24×7 Gated Community Security",
        "Avenue Plantation & Green Landscaping",
        "100% Vaastu Compliant Planning",
        "Immediate Registration Available",
        "Beautifully Designed Entrance Arch",
        "Children's Play Area & Parks",
        "Footpaths, Green Walkways & Street Lighting",
        "Overhead Water Tank with Pipeline Connection to Each Plot",
        "Well-Developed Common Areas"
      ],
      investmentReasons: [
        "Ideal for long-term investment",
        "High growth potential location",
        "Peaceful environment with future infrastructure development",
        "Perfect blend of nature and modern planning"
      ]
    },
    {
      id: 2,
      name: "Upcoming Project – Near Sri Shailam Highway",
      developer: "NAKSHATRA INFRA PROJECTS",
      location: "Sri Shailam Highway Corridor",
      type: "Premium RERA & DTCP Approved Open Plots",
      overview:
        "A premium 41-acre plotted development located in a fast-growing corridor near Sri Shailam Highway. Designed to deliver excellent connectivity and future appreciation, this project is ideal for investors looking for strong returns and families planning future construction.",
      keyInfo: {
        plotSizes: "Spacious & Well-Planned Plots",
        totalArea: "41 Acres",
        status: "Coming Soon",
        booking: "Open for Booking"
      },
      highlights: [
        "DTCP Approved Layout with Clear Documentation",
        "41 Acres Premium Plotted Development",
        "Wide Black Top Internal Roads",
        "24×7 Gated Community Security",
        "Vaastu-Friendly Plot Planning",
        "Avenue Plantation & Landscaped Open Spaces",
        "Immediate Registration",
        "Attractive Entrance Arch",
        "Children's Play Ground",
        "Green Walking Tracks & Footpaths",
        "Street Lights & Power Infrastructure",
        "Overhead Water Tank & Underground Pipelines",
        "Developed Parks & Common Open Areas"
      ],
      investmentReasons: [
        "Located near Sri Shailam Highway",
        "High appreciation zone",
        "Fast-developing residential corridor",
        "Suitable for both investment and future living"
      ]
    }
  ];

  const styles = {
    section: {
      padding: "80px 20px",
      background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
    },
    container: {
      maxWidth: "1400px",
      margin: "0 auto"
    },
    headerBadge: {
      display: "inline-block",
      padding: "8px 24px",
      background: "linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%)",
      color: "white",
      borderRadius: "30px",
      fontSize: "13px",
      fontWeight: "700",
      letterSpacing: "1.5px",
      textTransform: "uppercase",
      marginBottom: "20px",
      boxShadow: "0 4px 12px rgba(30, 58, 138, 0.3)"
    },
    mainTitle: {
      fontSize: "56px",
      fontWeight: "800",
      color: "#1a1a1a",
      marginBottom: "16px",
      letterSpacing: "-1px",
      textAlign: "center"
    },
    subtitle: {
      fontSize: "20px",
      color: "#4b5563",
      maxWidth: "800px",
      margin: "0 auto 60px",
      lineHeight: "1.6",
      textAlign: "center"
    },
    projectCard: {
      background: "white",
      borderRadius: "16px",
      marginBottom: "40px",
      boxShadow: "0 20px 60px rgba(0,0,0,0.12)",
      overflow: "hidden",
      border: "1px solid #e5e7eb",
      transition: "all 0.4s ease"
    },
    projectCardHover: {
      transform: "translateY(-8px)",
      boxShadow: "0 30px 80px rgba(0,0,0,0.18)"
    },
    projectHeader: {
      background: "linear-gradient(135deg, #1e3a8a 0%, #2563eb 100%)",
      padding: "50px 40px",
      position: "relative",
      overflow: "hidden"
    },
    projectHeaderPattern: {
      position: "absolute",
      top: 0,
      right: 0,
      width: "100%",
      height: "100%",
      opacity: 0.08,
      background: `repeating-linear-gradient(
        45deg,
        transparent,
        transparent 35px,
        rgba(255,255,255,0.1) 35px,
        rgba(255,255,255,0.1) 70px
      )`
    },
    developerTag: {
      fontSize: "12px",
      color: "rgba(255,255,255,0.9)",
      fontWeight: "700",
      letterSpacing: "2px",
      textTransform: "uppercase",
      marginBottom: "12px",
      position: "relative",
      zIndex: 1
    },
    projectName: {
      fontSize: "38px",
      fontWeight: "800",
      color: "white",
      marginBottom: "16px",
      position: "relative",
      zIndex: 1,
      letterSpacing: "-0.5px"
    },
    locationBar: {
      display: "flex",
      alignItems: "center",
      gap: "12px",
      fontSize: "16px",
      color: "rgba(255,255,255,0.95)",
      fontWeight: "500",
      position: "relative",
      zIndex: 1,
      flexWrap: "wrap"
    },
    projectBody: {
      padding: "50px 40px"
    },
    overview: {
      fontSize: "17px",
      lineHeight: "1.8",
      color: "#374151",
      marginBottom: "40px",
      borderLeft: "4px solid #3b82f6",
      paddingLeft: "24px",
      fontWeight: "400"
    },
    keyInfoGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
      gap: "20px",
      marginBottom: "50px"
    },
    keyInfoCard: {
      background: "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)",
      padding: "28px 24px",
      borderRadius: "12px",
      border: "2px solid #e2e8f0",
      transition: "all 0.3s ease"
    },
    keyInfoCardHover: {
      borderColor: "#3b82f6",
      transform: "translateY(-4px)",
      boxShadow: "0 8px 24px rgba(59,130,246,0.15)"
    },
    keyInfoLabel: {
      fontSize: "11px",
      color: "#64748b",
      textTransform: "uppercase",
      letterSpacing: "1.2px",
      fontWeight: "700",
      marginBottom: "8px"
    },
    keyInfoValue: {
      fontSize: "19px",
      fontWeight: "700",
      color: "#1e293b"
    },
    sectionTitle: {
      fontSize: "26px",
      fontWeight: "800",
      color: "#1e293b",
      marginBottom: "24px",
      display: "flex",
      alignItems: "center",
      gap: "10px",
      paddingBottom: "12px",
      borderBottom: "3px solid #3b82f6"
    },
    highlightsGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
      gap: "16px",
      marginBottom: "45px"
    },
    highlightItem: {
      display: "flex",
      alignItems: "flex-start",
      gap: "14px",
      padding: "16px 20px",
      background: "#fafafa",
      borderRadius: "8px",
      border: "1px solid #e5e7eb",
      transition: "all 0.3s ease",
      fontSize: "15px",
      color: "#374151"
    },
    highlightItemHover: {
      background: "#f0f9ff",
      borderColor: "#bfdbfe",
      transform: "translateX(4px)"
    },
    checkIcon: {
      color: "#10b981",
      fontWeight: "900",
      fontSize: "18px",
      flexShrink: 0,
      marginTop: "2px"
    },
    investmentGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
      gap: "20px"
    },
    investmentCard: {
      background: "linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)",
      padding: "24px",
      borderRadius: "12px",
      border: "2px solid #fbbf24",
      display: "flex",
      alignItems: "flex-start",
      gap: "14px",
      transition: "all 0.3s ease"
    },
    investmentCardHover: {
      transform: "scale(1.03)",
      boxShadow: "0 12px 30px rgba(251,191,36,0.3)"
    },
    investmentIcon: {
      fontSize: "18px",
      fontWeight: "900",
      color: "#d97706",
      flexShrink: 0,
      marginTop: "2px"
    },
    investmentText: {
      fontSize: "16px",
      fontWeight: "600",
      color: "#78350f",
      lineHeight: "1.5"
    },
    ctaSection: {
      marginTop: "80px",
      background: "linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%)",
      padding: "60px 40px",
      borderRadius: "20px",
      textAlign: "center",
      position: "relative",
      overflow: "hidden"
    },
    ctaPattern: {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      opacity: 0.1,
      background: `radial-gradient(circle at 20% 50%, white 1px, transparent 1px),
                   radial-gradient(circle at 80% 80%, white 1px, transparent 1px)`,
      backgroundSize: "50px 50px"
    },
    ctaTitle: {
      fontSize: "42px",
      fontWeight: "800",
      color: "white",
      marginBottom: "16px",
      position: "relative",
      zIndex: 1
    },
    ctaText: {
      fontSize: "20px",
      color: "rgba(255,255,255,0.9)",
      marginBottom: "32px",
      position: "relative",
      zIndex: 1
    },
    ctaButton: {
      padding: "18px 48px",
      background: "white",
      color: "#1e3a8a",
      border: "none",
      borderRadius: "50px",
      fontSize: "17px",
      fontWeight: "800",
      cursor: "pointer",
      transition: "all 0.3s ease",
      position: "relative",
      zIndex: 1,
      letterSpacing: "0.5px",
      textTransform: "uppercase",
      boxShadow: "0 8px 24px rgba(0,0,0,0.2)"
    },
    ctaButtonHover: {
      transform: "scale(1.05)",
      boxShadow: "0 12px 36px rgba(0,0,0,0.3)"
    }
  };

  const [hoveredCard, setHoveredCard] = useState(null);
  const [hoveredKeyInfo, setHoveredKeyInfo] = useState({});
  const [hoveredHighlight, setHoveredHighlight] = useState({});
  const [hoveredInvestment, setHoveredInvestment] = useState({});
  const [hoveredCTA, setHoveredCTA] = useState(false);

  return (
    <section style={styles.section}>
      <div style={styles.container}>
        <div style={{ textAlign: "center", marginBottom: "70px" }}>
          <span style={styles.headerBadge}>Coming Soon</span>
          <h1 style={styles.mainTitle}>Upcoming Projects</h1>
          <p style={styles.subtitle}>
            DTCP approved gated community projects designed for growth, security,
            and long-term value. Discover premium plotted developments in prime locations.
          </p>
        </div>

        {projects.map((project) => {
          const isCardHovered = hoveredCard === project.id;
          
          return (
            <div
              key={project.id}
              style={{
                ...styles.projectCard,
                ...(isCardHovered ? styles.projectCardHover : {})
              }}
              onMouseEnter={() => setHoveredCard(project.id)}
              onMouseLeave={() => setHoveredCard(null)}
            >
              <div style={styles.projectHeader}>
                <div style={styles.projectHeaderPattern}></div>
                <p style={styles.developerTag}>{project.developer}</p>
                <h2 style={styles.projectName}>{project.name}</h2>
                <div style={styles.locationBar}>
                  <span>📍 {project.location}</span>
                  <span style={{ color: "rgba(255,255,255,0.5)" }}>•</span>
                  <span>{project.type}</span>
                </div>
              </div>

              <div style={styles.projectBody}>
                <p style={styles.overview}>{project.overview}</p>

                <div style={styles.keyInfoGrid}>
                  {Object.entries(project.keyInfo).map(([key, value]) => {
                    const keyId = `${project.id}-${key}`;
                    return (
                      <div
                        key={key}
                        style={{
                          ...styles.keyInfoCard,
                          ...(hoveredKeyInfo[keyId] ? styles.keyInfoCardHover : {})
                        }}
                        onMouseEnter={() => setHoveredKeyInfo({ ...hoveredKeyInfo, [keyId]: true })}
                        onMouseLeave={() => setHoveredKeyInfo({ ...hoveredKeyInfo, [keyId]: false })}
                      >
                        <p style={styles.keyInfoLabel}>
                          {key.replace(/([A-Z])/g, ' $1').trim()}
                        </p>
                        <p style={styles.keyInfoValue}>{value}</p>
                      </div>
                    );
                  })}
                </div>

                <div style={{ marginBottom: "45px" }}>
                  <h3 style={styles.sectionTitle}>
                    <span>✨</span>
                    <span>Project Highlights</span>
                  </h3>
                  <div style={styles.highlightsGrid}>
                    {project.highlights.map((item, idx) => {
                      const highlightId = `${project.id}-highlight-${idx}`;
                      return (
                        <div
                          key={idx}
                          style={{
                            ...styles.highlightItem,
                            ...(hoveredHighlight[highlightId] ? styles.highlightItemHover : {})
                          }}
                          onMouseEnter={() => setHoveredHighlight({ ...hoveredHighlight, [highlightId]: true })}
                          onMouseLeave={() => setHoveredHighlight({ ...hoveredHighlight, [highlightId]: false })}
                        >
                          <span style={styles.checkIcon}>✓</span>
                          <span>{item}</span>
                        </div>
                      );
                    })}
                  </div>
                </div>

                <div>
                  <h3 style={styles.sectionTitle}>
                    <span>💡</span>
                    <span>Why Invest Here?</span>
                  </h3>
                  <div style={styles.investmentGrid}>
                    {project.investmentReasons.map((reason, idx) => {
                      const investId = `${project.id}-invest-${idx}`;
                      return (
                        <div
                          key={idx}
                          style={{
                            ...styles.investmentCard,
                            ...(hoveredInvestment[investId] ? styles.investmentCardHover : {})
                          }}
                          onMouseEnter={() => setHoveredInvestment({ ...hoveredInvestment, [investId]: true })}
                          onMouseLeave={() => setHoveredInvestment({ ...hoveredInvestment, [investId]: false })}
                        >
                          <span style={styles.investmentIcon}>★</span>
                          <span style={styles.investmentText}>{reason}</span>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          );
        })}

        <div style={styles.ctaSection}>
          <div style={styles.ctaPattern}></div>
          <h3 style={styles.ctaTitle}>Ready to Invest in Your Future?</h3>
          <p style={styles.ctaText}>
            Get early access to these premium projects with exclusive investor benefits
          </p>
          <button
            style={{
              ...styles.ctaButton,
              ...(hoveredCTA ? styles.ctaButtonHover : {})
            }}
            onMouseEnter={() => setHoveredCTA(true)}
            onMouseLeave={() => setHoveredCTA(false)}
          >
            Contact Us Today
          </button>
        </div>
      </div>
    </section>
  );
};

export default UpcomingProjects;